<template>
  <div class="announcements-button-wrapper">
    <v-tooltip location="bottom">
      <template v-slot:activator="{ props: tooltipActivatorProps }">
        <v-btn
          v-bind="tooltipActivatorProps"
          variant="text"
          color="primary"
          @click="openDialog"
          :class="{ 'has-announcements': undismissedCount > 0 }"
        >
          <v-badge
            v-if="undismissedCount > 0"
            :content="undismissedCount"
            color="error"
            floating
            location="top end"
          >
            <v-icon size="24">mdi-bullhorn</v-icon>
          </v-badge>
          <v-icon v-else size="24">mdi-bullhorn-outline</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('announcements.button.label') }}</span>
    </v-tooltip>

    <AnnouncementsDialog v-model="dialogOpen" />
  </div>
</template>

<script>
import { useAnnouncementStore } from '@/stores/AnnouncementStore.js';
import AnnouncementsDialog from './AnnouncementsDialog.vue';

export default {
  name: 'AnnouncementsButton',
  components: {
    AnnouncementsDialog,
  },
  data() {
    return {
      dialogOpen: false,
    };
  },
  computed: {
    announcementStore() {
      return useAnnouncementStore();
    },
    undismissedCount() {
      return this.announcementStore.getVisibleCount;
    },
  },
  methods: {
    async openDialog() {
      await this.announcementStore.fetchActiveAnnouncements();
      this.dialogOpen = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.announcements-button-wrapper {
  display: inline-flex;
}
</style>
